

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      <div className="flex justify-center mb-4">
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="flex-shrink-0"
        >
          <rect width="64" height="64" rx="12" fill="var(--color-primary)" />
          <path
            d="M16 24h12v-4H16v4zm0 8h12v-4H16v4zm0 8h12v-4H16v4zm16-16h16v-4H32v4zm0 8h16v-4H32v4zm0 8h16v-4H32v4z"
            fill="var(--color-primary-foreground)"
          />
          <path
            d="M20 44l12-12-12-12v24z"
            fill="var(--color-accent)"
          />
        </svg>
      </div>
      <h1 className="text-3xl font-bold text-foreground mb-2">TaxQuery Pro</h1>
      <p className="text-muted-foreground">
        Sistema de Consulta Tributária Corporativa
      </p>
    </div>
  );
};

export default LoginHeader;